export const contractProgressInfo = [
  {
    title: 'Adams Row, Mayfair, W1K',
    percentage: 60,
    color: 'rgb(42,121,66,0.85)',
  },
  {
    title: 'Bathurst Street, Hyde Park Estate, W2',
    percentage: 40,
    color: 'rgb(42,121,66,0.65)',
  },
  {
    title: 'Elgin Avenue, Maida Vale, W9',
    percentage: 50,
    color: 'rgb(42,121,66,0.775)',
  },
  {
    title: 'Headfort Place, Belgravia, SW1X',
    percentage: 80,
    color: 'rgb(42,121,66,1)',
  },
  {
    title: 'Maida Vale, Maida Vale, W9',
    percentage: 20,
    color: 'rgb(42,121,66,0.5)',
  },
];

